import { FORM_DATA_ACTION_TYPE } from '../../../utils/constants.js';
const formDataReducer = (state, action) => {
   const { type } = action;

   switch (type) {
      case FORM_DATA_ACTION_TYPE.ADD_FIELD: {
         const { sectionKey, field, key, value, operator } = action.payload;
         return {
            ...state,
            [sectionKey]: [
               ...(state[sectionKey] || []),
               {
                  key,
                  field,
                  value,
                  operator,
               },
            ],
         };
      }
      case FORM_DATA_ACTION_TYPE.UPDATE_FIELD: {
         const { sectionKey, key, value, operator } = action.payload;

         const updatedSection = state[sectionKey].map((field) =>
            field.key === key
               ? {
                    ...field,
                    value,
                    operator,
                 }
               : field
         );
         return {
            ...state,
            [sectionKey]: updatedSection,
         };
      }
      case FORM_DATA_ACTION_TYPE.UPDATE_SECTION: {
         const { sectionKey, key, field, value, operator } = action.payload;
         const updatedSection = state[sectionKey].map(() => ({
            key,
            field,
            value,
            operator,
         }));
         return {
            ...state,
            [sectionKey]: updatedSection,
         };
      }
      case FORM_DATA_ACTION_TYPE.RESET_FORM: {
         return {};
      }
      default: {
      }
   }
};

export default formDataReducer;
